var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftEntraId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4134_2244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1334 37.7467C11.1734 38.3867 12.88 39.1067 14.72 39.1067C16.3734 39.1067 17.92 38.6267 19.2 37.8L24 34.7867V45.64C23.2267 45.64 22.48 45.4267 21.8134 45.0267L10.16 37.7467H10.1334Z",
    fill: "#225086"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9333 4.36L0.933328 26.92C-0.613338 28.6533 -0.213338 31.2933 1.78666 32.5467C1.78666 32.5467 9.19999 37.16 10.1333 37.7467C11.1733 38.3867 12.88 39.1067 14.72 39.1067C16.3733 39.1067 17.92 38.6267 19.2 37.8L24 34.7867L12.3733 27.5067L24 14.3867V3C22.88 3 21.7333 3.45333 20.9333 4.36Z",
    fill: "#66DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3734 27.5333L12.5067 27.6133L24 34.8133V14.4133L12.3734 27.5333Z",
    fill: "#CBF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1867 32.5467C48.1867 31.2933 48.5867 28.6533 47.04 26.92L33.92 12.12C32.8533 11.64 31.68 11.3467 30.4267 11.3467C27.9467 11.3467 25.76 12.4133 24.2933 14.0933L24 14.4133L35.6267 27.5333L24 34.8133V45.6667C24.7733 45.6667 25.52 45.4534 26.1867 45.0533L46.1867 32.5467Z",
    fill: "#074793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 3V14.4133L24.2933 14.0933C25.76 12.4133 27.9733 11.3467 30.4267 11.3467C31.68 11.3467 32.88 11.64 33.92 12.12L27.04 4.36C26.2667 3.45333 25.12 3 24 3Z",
    fill: "#0294E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6267 27.5333L24 14.4133V34.8133L35.6267 27.5333Z",
    fill: "#96BCC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4134_2244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftEntraId);
export default __webpack_public_path__ + "static/media/Microsoft_entra_ID.66e2a204654533d607c8c084d8649775.svg";
export { ForwardRef as ReactComponent };